// import parseTime, formatTime and set to filter
export { parseTime } from "@/utils/common";

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + "s";
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), " minute");
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), " hour");
  } else {
    return pluralize(~~(between / 86400), " day");
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1e18, symbol: "E" },
    { value: 1e15, symbol: "P" },
    { value: 1e12, symbol: "T" },
    { value: 1e9, symbol: "G" },
    { value: 1e6, symbol: "M" },
    { value: 1e3, symbol: "k" }
  ];
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value + 0.1)
          .toFixed(digits)
          .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") + si[i].symbol
      );
    }
  }
  return num.toString();
}

/**
 * 数值小数格式化
 * like 10000 => 10000.00
 * @param {number} value
 * @param {number} num
 */
export function numberRound(value, num) {
  let _value = value.toString();
  const _dot = _value.indexOf(".");
  const _valueLen = _value.length;
  if (num === 0) {
    if (_dot !== -1) {
      _value = _value.substring(0, _dot);
    }
  } else {
    // 如果没有小数点
    if (_dot === -1) {
      _value = _value + ".";
      for (let i = 1; i <= num; i++) {
        _value = _value + "0";
      }
    } else {
      // 有小数点，超出位数自动截取，否则补0
      _value = _value.substring(0, _dot + num + 1);
      for (let i = _valueLen; i <= _dot + num; i++) {
        _value = _value + "0";
      }
    }
  }
  return _value;
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0)
    .toString()
    .replace(/^-?\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function formatterDateTime(date) {
  if (!date) {
    return "";
  }
  const currDate = new Date(date);
  if (isNaN(currDate)) {
    return date;
  }
  const year = currDate.getFullYear().toString();
  let month = currDate.getMonth() + 1;
  let day = currDate.getDate().toString();
  let hour = currDate.getHours().toString();
  let minutes = currDate.getMinutes().toString();
  let seconds = currDate.getSeconds().toString();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  if (hour < 10) {
    hour = "0" + hour;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  if (year === "NaN" || month === "NaN") {
    return "";
  }
  return (
    year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds
  );
}

export function formatterTime(date) {
  if (!date) {
    return "";
  }
  date = new Date(date);
  const year = date.getFullYear().toString();
  let month = date.getMonth() + 1;
  let day = date.getDate().toString();
  let hour = date.getHours().toString();
  let minutes = date.getMinutes().toString();
  let seconds = date.getSeconds().toString();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  if (hour < 10) {
    hour = "0" + hour;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  if (year === "NaN" || month === "NaN") {
    return "";
  }
  return hour + ":" + minutes + ":" + seconds;
}

export function formatterDate(date) {
  if (!date) {
    return "";
  }
  date = new Date(date);
  const year = date.getFullYear().toString();
  let month = date.getMonth() + 1;
  let day = date.getDate().toString();
  let hour = date.getHours().toString();
  let minutes = date.getMinutes().toString();
  let seconds = date.getSeconds().toString();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  if (hour < 10) {
    hour = "0" + hour;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  if (year === "NaN" || month === "NaN") {
    return "";
  }
  return year + "-" + month + "-" + day;
}

export function formatterFileSize(size) {
  if (!size) {
    return "";
  }
  const num = 1024.0;
  if (size < num) {
    return size + "B";
  }
  if (size < Math.pow(num, 2)) {
    return (size / num).toFixed(2) + "KB";
  }
  if (size < Math.pow(num, 3)) {
    return (size / Math.pow(num, 2)).toFixed(2) + "M";
  }
  if (size < Math.pow(num, 4)) {
    return (size / Math.pow(num, 3)).toFixed(2) + "G";
  }
  return (size / Math.pow(num, 4)).toFixed(2) + "T"; // T
}

// 参数说明：
// number：要格式化的数字
// decimals：保留几位小数
// dec_point：小数点符号
// thousands_sep：千分位符号
export function numberFormat(number, decimals, dec_point, thousands_sep) {
  number = (number + "").replace(/[^0-9+-Ee.]/g, "");
  const n = !isFinite(+number) ? 0 : +number;
  const prec = !isFinite(+decimals) ? 2 : Math.abs(decimals);
  const sep = typeof thousands_sep === "undefined" ? "," : thousands_sep;
  const dec = typeof dec_point === "undefined" ? "." : dec_point;
  let s = "";
  const toFixedFix = function(n, prec) {
    const k = Math.pow(10, prec);
    return "" + Math.ceil(n * k) / k;
  };

  s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
  const re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, "$1" + sep + "$2");
  }

  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }
  return s.join(dec);
}

// 跟进状态格式化
export function formatFollowState(state, options) {
  options.forEach((option) => {
    if (option.value === state) {
      state = option.label;
    }
  });
  return state;
}

export function moneyToBig(n) {
  if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
    return "";
  }
  let unit = "仟佰拾亿仟佰拾万仟佰拾圆角分";
  let str = "";
  n += "00";
  const p = n.indexOf(".");
  if (p >= 0) {
    n = n.substring(0, p) + n.substr(p + 1, 2);
  }

  unit = unit.substr(unit.length - n.length);

  for (let i = 0; i < n.length; i++) {
    str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
  }
  return str
    .replace(/零(仟|佰|拾|角)/g, "零")
    .replace(/(零)+/g, "零")
    .replace(/零(万|亿|圆)/g, "$1")
    .replace(/(亿)万|壹(拾)/g, "$1$2")
    .replace(/^圆零?|零分/g, "")
    .replace(/圆$/g, "圆整");
}
